<script setup lang="ts">
  import { useNotification } from "./useNotification";
  import Notification from "./Notification.vue";

  const { isMobile } = defineProps<{ isMobile?: boolean }>();

  const { notification, clear } = useNotification();
</script>

<template>
  <div :class="['notification-container', { 'mobile': isMobile }]">
    <Notification
      v-for="n in notification ? [notification] : []"
      :key="n.id"
      data-testid="notification-item"
      :title="n.title"
      :description="n.description"
      :type="n.type"
      :duration="n.duration"
      :align="isMobile ? 'center' : n.align"
      @close="clear"
    />
  </div>
</template>

<style scoped>
  .notification-container {
    position: fixed;
    top: 20px;
    left: 20px;
    right: 20px;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .notification-container.mobile {
    top: 44px;
  }

  .notification-list-move {
    transition: all 0.3s ease;
  }
</style>
